import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
import { Lock, ShieldCheck } from 'lucide-react';
export function OfferBlock() {
  return <section id="offer-section" className="py-24 bg-brand-dark relative overflow-hidden" data-id="element-69">
      {/* Decorative background rays */}
      <div className="absolute inset-0 opacity-10" data-id="element-70">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[conic-gradient(from_0deg,transparent_0_340deg,white_360deg)] animate-[spin_10s_linear_infinite]" data-id="element-71" />
      </div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-72">
        <div className="max-w-4xl mx-auto" data-id="element-73">
          <FadeIn data-id="element-74">
            <div className="text-center mb-12" data-id="element-75">
              <h2 className="text-3xl md:text-4xl font-bold text-brand-cream mb-6" data-id="element-76">
                Recupera tu tranquilidad hoy mismo.
              </h2>
              <p className="text-xl text-brand-cream/80" data-id="element-77">
                Olvídate de pagar suscripciones mensuales de $59. Obtén el
                sistema completo de "Borrón y Cuenta Nueva" por un pago único.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} direction="up" data-id="element-78">
            <div className="bg-white rounded-3xl p-8 md:p-12 text-center shadow-2xl border-4 border-brand-gold relative max-w-2xl mx-auto" data-id="element-79">
              {/* Badge */}
              <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-brand-rose text-white px-6 py-2 rounded-full font-bold text-sm tracking-wide shadow-lg whitespace-nowrap" data-id="element-80">
                PRECIO ESPECIAL DE LANZAMIENTO
              </div>

              <div className="my-8" data-id="element-81">
                <div className="flex items-center justify-center gap-4 mb-2" data-id="element-82">
                  <span className="text-3xl text-gray-400 line-through font-medium" data-id="element-83">
                    $59 USD
                  </span>
                </div>
                <div className="text-6xl md:text-7xl font-black text-brand-dark flex items-start justify-center" data-id="element-84">
                  <span className="text-3xl mt-2 mr-1" data-id="element-85">$</span>
                  6.36
                  <span className="text-2xl mt-auto mb-2 ml-2 text-gray-500 font-medium" data-id="element-86">
                    USD
                  </span>
                </div>
              </div>

              <CTAButton className="w-full text-lg py-5 mb-6" data-id="element-87">
                ¡QUIERO MI CRÉDITO LIMPIO AHORA!
              </CTAButton>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-gray-600 font-medium" data-id="element-88">
                <div className="flex items-center gap-2" data-id="element-89">
                  <Lock className="w-4 h-4 text-green-600" data-id="element-90" />
                  Compra 100% segura.
                </div>
                <div className="hidden sm:block text-gray-300" data-id="element-91">•</div>
                <div className="flex items-center gap-2" data-id="element-92">
                  <ShieldCheck className="w-4 h-4 text-brand-gold" data-id="element-93" />
                  Acceso instantáneo tras el pago.
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}